export default "__VITE_ASSET__C3rlBVPg__"